import React from 'react';
import { FormField } from 'src/components/FormField';
import { TextInput } from 'src/components/TextInput';
import { Row } from 'src/components/Row';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Form } from '../types';

interface CoordinateInputsProps {
  register: UseFormRegister<Form>;
  errors: FieldErrors<Form>;
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>, index: number, coord: 'x' | 'y') => void;
  disabled?: boolean;
}

const CoordinateInputs: React.FC<CoordinateInputsProps> = ({
  register,
  errors,
  handleFormChange,
  disabled = false,
}) => {
  return (
    <>
      <Row className="gap-2">
        <FormField label="X1">
          <TextInput
            {...register('x1')}
            error={errors.x1?.message}
            onChange={(e) => handleFormChange(e, 0, 'x')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="Y1">
          <TextInput
            {...register('y1')}
            error={errors.y1?.message}
            onChange={(e) => handleFormChange(e, 0, 'y')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="X2">
          <TextInput
            {...register('x2')}
            error={errors.x2?.message}
            onChange={(e) => handleFormChange(e, 1, 'x')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="Y2">
          <TextInput
            {...register('y2')}
            error={errors.y2?.message}
            onChange={(e) => handleFormChange(e, 1, 'y')}
            disabled={disabled}
          />
        </FormField>
      </Row>
      <Row className="gap-2">
        <FormField label="X3">
          <TextInput
            {...register('x3')}
            error={errors.x3?.message}
            onChange={(e) => handleFormChange(e, 2, 'x')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="Y3">
          <TextInput
            {...register('y3')}
            error={errors.y3?.message}
            onChange={(e) => handleFormChange(e, 2, 'y')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="X4">
          <TextInput
            {...register('x4')}
            error={errors.x4?.message}
            onChange={(e) => handleFormChange(e, 3, 'x')}
            disabled={disabled}
          />
        </FormField>
        <FormField label="Y4">
          <TextInput
            {...register('y4')}
            error={errors.y4?.message}
            onChange={(e) => handleFormChange(e, 3, 'y')}
            disabled={disabled}
          />
        </FormField>
      </Row>
    </>
  );
};

export default CoordinateInputs;
